(function () {
  'use strict';
  var T = window.theme || {};
  var R = T.routes || {};
  var STR = T.strings || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- toast ---- */
  var toastEl = $('#toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2400);
  }

  /* ---- cart drawer ---- */
  var drawer = $('#cart-drawer');
  var scrim = $('[data-cart-scrim]');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('on'); scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('on'); scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function bump() {
    var b = $('.cart-btn'); if (!b) return;
    b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
  }

  // Re-render the drawer from the server (Section Rendering API).
  function refresh() {
    return fetch(R.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-drawer-inner]', doc);
        var cur = $('[data-drawer-inner]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
          setCount(fresh.getAttribute('data-item-count') || '0');
        }
      });
  }

  function addToCart(payload, opts) {
    opts = opts || {};
    var isForm = (typeof FormData !== 'undefined') && payload instanceof FormData;
    var init = {
      method: 'POST',
      body: isForm ? payload : JSON.stringify(payload),
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    };
    return fetch(R.cartAdd + '.js', init)
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        if (!x.ok || x.d.status) { toast(x.d.description || x.d.message || STR.error); return; }
        return refresh().then(function () {
          bump();
          if (opts.open) openCart(); else toast(STR.added);
        });
      })
      .catch(function () { toast(STR.error); });
  }

  function changeLine(key, qty) {
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () { toast(STR.error); });
  }

  /* ---- clicks (delegated) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-close-cart],[data-cart-scrim],[data-quick-add],[data-line-change],[data-qty-step],[data-thumb]');
    if (!t) return;

    if (t.hasAttribute('data-open-cart')) {
      e.preventDefault(); openCart(); refresh();
    } else if (t.hasAttribute('data-close-cart') || t.hasAttribute('data-cart-scrim')) {
      closeCart();
    } else if (t.hasAttribute('data-quick-add')) {
      e.preventDefault();
      addToCart({ items: [{ id: Number(t.getAttribute('data-variant-id')), quantity: 1 }] });
    } else if (t.hasAttribute('data-line-change')) {
      changeLine(t.getAttribute('data-key'), Number(t.getAttribute('data-qty')));
    } else if (t.hasAttribute('data-qty-step')) {
      var input = $('.qty-input', t.parentNode);
      if (input) {
        var next = (parseInt(input.value, 10) || 1) + Number(t.getAttribute('data-qty-step'));
        input.value = Math.max(1, Math.min(20, next));
      }
    } else if (t.hasAttribute('data-thumb')) {
      var wrap = $('[data-main-image-wrap] img');
      if (wrap) { wrap.removeAttribute('srcset'); wrap.removeAttribute('sizes'); wrap.src = t.getAttribute('data-src'); }
      $$('[data-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    }
  });

  /* ---- product form: add without leaving the page ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('button[type="submit"]', form);
    if (btn) btn.disabled = true;
    addToCart(new FormData(form), { open: true }).then(function () { if (btn) btn.disabled = false; });
  });

  /* ---- variant picker: update price ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = $('[data-price]');
    if (!priceEl || !opt) return;
    var html = opt.getAttribute('data-price') || '';
    var cmp = opt.getAttribute('data-compare');
    priceEl.innerHTML = html + (cmp ? '<s>' + cmp + '</s>' : '');
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // Back/forward cache: make sure the count is fresh.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
